import React from 'react';
import SEO from '../components/SEO';
import AuthorBio from '../components/AuthorBio';

const content = {
  es: {
    seoTitle: "Sobre el Creador | Barberà del Vallès Fit",
    seoDesc: "Conoce a Mathias Deppe, el diseñador instruccional detrás de la guía de compra de Mercadona en Barberà. Misión, valores y transparencia.",
    aboutTitle: "Sobre el Creador",
    name: "Mathias Deppe",
    aboutText: "Soy Mathias: diseñador instruccional, creador visual y residente en Barberà. Entreno calistenia en casa, no CrossFit, pero mi novia sí, y el dueño del box local es amigo mío. Al ver a los atletas salir del box todos los días y arruinar la mitad de su progreso en la cocina, hice lo que mejor sé hacer: convertí los mejores consejos de los coaches en algo en lo que nadie tiene que pensar dos veces: una lista de la compra del Mercadona simple y visual. Yo ordeno el caos. Tú obtienes los resultados.",
    missionTitle: "Misión: Simplificando el Fitness Local",
    missionText: "Mi experiencia en diseño instruccional me enseñó que el progreso rara vez se estanca por falta de información, sino por exceso de ella. En el fitness, eso se traduce en dietas imposibles y consejos contradictorios. Ese es el vacío que lleno: tomar el conocimiento técnico que ya tienen los mejores coaches de CrossFit de Barberà y convertirlo en algo visual y utilizable hoy.",
    noSellTitle: "Lo que NO vendo",
    noSellText: "Cero suplementos. Cero programas mágicos. Solo claridad — porque una vez que el camino está despejado, el esfuerzo es lo único que te queda por aportar."
  },
  en: {
    seoTitle: "About the Creator | Barberà del Vallès Fit",
    seoDesc: "Meet Mathias Deppe, the instructional designer behind the Barberà Mercadona grocery guide. Mission, values, and transparency.",
    aboutTitle: "About the Creator",
    name: "Mathias Deppe",
    aboutText: "I'm Mathias — an instructional designer, visual creator, and Barberà resident. I train calisthenics at home, not CrossFit — but my girlfriend does, and the owner of the local box is a friend of mine. Watching athletes from the box leave every day and undo half their progress in the kitchen, I did what I actually know how to do: turned the coaches' best advice into something nobody has to think twice about — a simple, visual Mercadona grocery list. I organize the chaos. You get the results.",
    missionTitle: "Mission: Simplifying Local Fitness",
    missionText: "My background in instructional design taught me that progress rarely stalls from a lack of information — it stalls from too much of it. In fitness, that shows up as impossible diets and advice that contradicts itself. That's the gap I fill: taking the technical knowledge already sitting with Barberà's best CrossFit coaches and turning it into something visual and usable today.",
    noSellTitle: "What I Don't Sell",
    noSellText: "No supplements. No magic programs. Just clarity — because once the path is clear, effort is the only thing left for you to provide."
  }
};

export default function AboutPage({ lang }) {
  const t = content[lang];

  return (
    <div className="min-h-screen pb-20">
      <SEO 
        title={t.seoTitle} 
        description={t.seoDesc} 
        lang={lang} 
        path="/about"
      />
      
      <main className="max-w-3xl mx-auto px-6 py-12">
        <header className="mb-12 space-y-4">
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-none tracking-tighter italic font-display">
            {t.aboutTitle}
          </h1>
          <div className="h-1.5 w-24 bg-orange-600"></div>
        </header>

        {/* Professional Trust Card */}
        <div className="mb-16">
          <AuthorBio lang={lang} />
        </div>

        {/* Intro Section */}
        <section className="mb-16">
          <p className="text-xl md:text-2xl text-slate-200 leading-relaxed font-medium">
            {t.aboutText}
          </p>
        </section>

        {/* Mission Section with Accent Border */}
        <section className="mb-16 border-l-4 border-orange-500 pl-8 py-2">
          <h2 className="text-3xl font-display font-bold text-white uppercase italic mb-6 tracking-tight">
            {t.missionTitle}
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            {t.missionText}
          </p>
        </section>

        {/* "What I Don't Sell" Value Card */}
        <section className="bg-slate-900/80 border border-slate-800 p-8 rounded-2xl weathered-border">
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            <div className="shrink-0">
              <div className="w-12 h-12 bg-orange-600/20 rounded-full flex items-center justify-center border border-orange-600/30">
                <span className="text-orange-500 font-black text-xl">!</span>
              </div>
            </div>
            <div className="space-y-2">
              <h3 className="text-2xl font-display font-bold text-white uppercase italic tracking-tight">
                {t.noSellTitle}
              </h3>
              <p className="text-slate-300 text-lg leading-relaxed">
                {t.noSellText}
              </p>
            </div>
          </div>
        </section>

        {/* Localized Footer Signal */}
        <div className="mt-24 pt-8 border-t border-slate-900 flex flex-col sm:flex-row justify-between items-center gap-4 opacity-50">
          <span className="text-[10px] font-black uppercase tracking-[0.4em] text-slate-500">
            Barberà del Vallès • instructional design
          </span>
          <div className="flex gap-2">
            {[1, 2, 3].map(i => (
              <div key={i} className="w-2 h-2 bg-slate-800 rotate-45" />
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}